import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import { Logger } from '../../../../common/core/utilities/logging/logger';

declare var $: any;
@Component({
  selector: 'year-month-picker',
  standalone: true,
  templateUrl: './month-date-picker.component.html',
  styleUrls: ['./month-date-picker.component.scss'],
})
export class MonthDatePickerComponent implements OnChanges, AfterViewInit {
  // @Input() minDate!: NgbDateStruct;
  // @Input() maxDate!: NgbDateStruct;

  // @Output() onDateChange = new EventEmitter()
  // date!: { year: number };
  data: Date = new Date();

  @Input() minValue: Date = this.data;
  @Input() maxValue: Date = this.data;
  @Input() defaultValue: { from: Date; to: Date } = {
    from: this.data,
    to: this.data,
  };
  @Input() classDate?: string;

  @Output() onDateChange: EventEmitter<{ from?: Date; to?: Date }> =
    new EventEmitter<{ from?: Date; to?: Date }>();
  id: string = `${new Date().getTime()}`;

  ngOnChanges(changes: SimpleChanges): void {
    this.ngAfterViewInit();
  }
  ngAfterViewInit(): void {
    const checkin = $('#' + this.id)
      .datepicker({
        format: 'mm-yyyy',
        startView: 'months',
        viewMode: 'months',
        minViewMode: 'months',
        minDate: this.minValue,
        maxDate: `+5Y`,
        onRender: (date: any) => {
          return date.valueOf() > this.maxValue.valueOf() ||
            date.valueOf() < this.minValue.valueOf()
            ? 'disabled'
            : '';
        },
      })
      .on('changeDate', (ev: any) => {
        checkin.hide();
        Logger.debug();
        // new Date() >= ev.date ? [Logger.debug('ev', ev, $('#' + this.id)), this.onDateChange.emit(ev.date)] : null;
        this.onDateChange.emit(ev.date);
      })
      .data('datepicker');
    $('#' + this.id).datepicker('setValue', this.defaultValue);
  }

  openPicker() {
    $('#' + this.id).datepicker('show');
  }
}
